import { render, staticRenderFns } from "./provider-articles.vue?vue&type=template&id=2827d807&scoped=true&lang=pug&"
import script from "./provider-articles.vue?vue&type=script&lang=js&"
export * from "./provider-articles.vue?vue&type=script&lang=js&"
import style0 from "./provider-articles.vue?vue&type=style&index=0&id=2827d807&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2827d807",
  null
  
)

/* custom blocks */
import block0 from "./provider-articles.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteBlogPreview: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/site/blog/preview.vue').default})
